import React from "react";
import { connect } from "react-redux";
import { Col, Badge } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalButton from "../../../layout/conditional-button";

import { send as pageInfo, loading } from "../../../actions/page";
import { search as getCalendars } from "../../../actions/calendar";
import { withNavigation } from "../../../utils/wrapper";

import { initialState, onDateFormat, onCurrencyFormat, onLinkFormat } from "../../../layout/table/helpers";

const BASE_URL = "/dashboard/settings/calendars/";

class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "caption",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0,
            default: ""
        };
        this.props.loading(true);
        this.props.pageInfo({ title: "Calendars", breadcrumb: `Calendars` });
    }

    get headers() {
        return [
            {
                header: "Caption",
                sortable: false,
                source: "caption",
                className: "text-muted text-small text-uppercase w-25",
                onRender: (e, row) =>  this.getCaption(e, row),
            },
            {
                header: "Owner",
                sortable: false,
                source: "uuid",
                className: "text-muted text-small text-uppercase w-60",
                onRender: (e, row) => this.onNameLinkFormat("Person", e, row)
            },
            {
                header: "Created By",
                sortable: false,
                source: "uuid",
                className: "text-muted text-small text-uppercase w-60",
                onRender: (e, row) => this.onNameLinkFormat("CreatedBy", e, row)
            },
        ]
    }

    getCaption = (caption, row) => {
        const isFirm = row?.style === "Firm";
        return (
            <a href={`/dashboard/settings/calendars/${row?.uuid}`}>
                {caption}
                {isFirm ? (
                    <>
                        {" "}
                        <Badge pill bg="warning" text="dark">
                            Firm Calendar
                        </Badge>
                    </>
                ) : null}
            </a>
        );        
    }

    onNameLinkFormat = (record, _e, row) => {
        const p = row?.[record];
        const last = p?.lastName || "";
        const first = p?.firstName || "";
        const name = (last || first) ? `${last}${last && first ? ", " : ""}${first}` : "—";

        return (
            <a href={`/dashboard/settings/calendars/${row?.uuid}`}>
                {name}
            </a>
        );
    };

    loadData = async () => {
        this.props.loading(true);
        const items = await this.props.getCalendars({});
        //const system = await this.props.getSetting({ name: "FERA_EMAIL_CONFIGURATION" });
        this.setState({
            data: [...items.items],
            //system: system?.value
        });
        this.props.loading(false);
    }
    
    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }


    onNewClick = (e) => {
        this.props.navigate("add");
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new calendar" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        size={this.state.size}
                        index={0}
                        pages={1}
                        searchable={false}
                        sizable={false}
                        sortable={false}
                    />
                </Col>

            </>
    )}
}

Settings.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { pageInfo, loading, getCalendars })(Settings));
